import clsx from 'clsx';
import { FunctionComponent } from 'react';
import styles from './OldTitle.module.css';

interface TitleProps {
    title: string;
    className?: string;
}

export const Title: FunctionComponent<TitleProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <span className={styles.title}>{props.title}</span>
        </div>
    );
};

export default Title;
